module.exports = __webpack_public_path__ + "img/web-links.0b45491a.png";